export default "__VITE_ASSET__Ub9xvdJV__"